import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { EddyAutoComplete, Imovel, LoginContabil, PlanoConta, Terreno } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { PlanoContaService } from '../../tesouraria/service/plano-conta.service';
import { BemImovelTerrenoService } from '../service/bem-imovel-terreno.service';

@Component({
  selector: 'app-bem-imovel-terreno',
  templateUrl: './bem-imovel-terreno.component.html'
})
export class BemImovelTerrenoComponent implements OnInit, OnChanges, OnDestroy {

  protected unsubscribe: Subject<void> = new Subject();

  @Input() lista: Terreno[] = [];
  @Input() bemImovel: Imovel;
  @Input() login: LoginContabil;
  @Output() totalTerrenos = new EventEmitter<number>();


  public imaskConfigValorComVirgula = {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected terrenoService: BemImovelTerrenoService,
    protected planoContaService: PlanoContaService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes): void {
    if (changes?.bemImovel?.currentValue?.id) {
      this.filtrar();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public adicionar() {
    if (!this.lista) {
      this.lista = [];
    }
    this.planoContaService.filtrar(1, -1, { codigo: '123210104', 'exercicio.id': this.login.exercicio.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista.unshift(new Terreno(null, null, null, null, res.content[0], this.bemImovel));
        this.lista[0]['editavel'] = true;
      });

  }

  public salvar(item: Terreno) {
    try {
      if (!item.descricao) throw new Error('Informe a descrição do terreno!');
      if (!item.endereco) throw new Error('Informe o endereço do terreno!');
      if (!item.plano_conta) throw new Error('Informe a conta contábil!');
      if (!item.valor_terreno && item.valor_terreno !== 0) throw new Error('Informe o valor do terreno!');

      item.imovel = this.bemImovel;

      const requisicao = item.id
        ? this.terrenoService.atualizar(item)
        : this.terrenoService.inserir(item);

      requisicao.pipe(takeUntil(this.unsubscribe))
        .subscribe(() => {
          toastr.info(`Registro ${item.id ? 'alterado' : 'inserido'} com sucesso!\nSalve o imóvel para persistir o valor calculado do terreno!`);
          let total = 0;
          for (let terreno of this.lista) {
            total += +terreno.valor_terreno;
          }
          this.totalTerrenos.emit(total);
          this.filtrar();
        });
    } catch (e) {
      toastr.error(e.message);
      throw e;
    }
  }

  public editar(item: Terreno) {
    item['editavel'] = true;
  }

  public cancelar(item: Terreno) {
    item['editavel'] = false;

    if (!item.id) {
      this.lista.splice(this.lista.findIndex(i => i === item), 1);
      return;
    }

    this.filtrar();
  }

  public remover(item: Terreno) {
    this.lista.splice(this.lista.findIndex(i => i === item), 1);
    if (!item.id) {
      return;
    }

    this.terrenoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        toastr.info('Registro removido com sucesso!');
        let total = 0;
        for (let terreno of this.lista) {
          total += +terreno.valor_terreno;
        }
        this.totalTerrenos.emit(total);
        this.filtrar();
      });
  }

  public trackById(index: number, item: Terreno): number {
    return item.id;
  }

  private filtrar() {
    this.terrenoService.obterPorImovel(this.bemImovel.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((terrenos) => {
        this.lista = Array.from(terrenos as Terreno[])
      }
      );
  }
}
